import { getFormFieldValidations, isEmailValid } from '@avalara/bat-apps-shared/lib/form-validation';
import { requiredFormFields } from '../reducers/helpers/forms-constants';
export const isFieldMissing = (state) => (field) => {
    var _a;
    return ((state.signupForm.country !== 'US' && state.signupForm.country !== 'CA' && field === 'postalCode')
        ? false
        : !((_a = state.signupForm[field]) === null || _a === void 0 ? void 0 : _a.trim())
            && (requiredFormFields.includes(field) || state.additionalRequiredFields.includes(field)));
};
export const isFieldInvalid = ({ signupForm, useEcmCompanyLength }) => (field) => {
    if (field === 'street1' && [signupForm.street1, signupForm.street2].filter(Boolean).join(' ').length > 50)
        return true;
    if ((signupForm.country !== 'US' && signupForm.country !== 'CA')
        && (field === 'postalCode' || field === 'state'))
        return false;
    if (field === 'email')
        return !isEmailValid(signupForm.email);
    const fieldValidations = getFormFieldValidations(signupForm.country, useEcmCompanyLength);
    return Boolean(fieldValidations[field] && !fieldValidations[field].test(signupForm[field] || ''));
};
const isFieldMissingOrInvalid = (state) => (field) => {
    const normalValidation = isFieldMissing(state)(field) || isFieldInvalid(state)(field);
    if (field === 'email') {
        return normalValidation || !state.emailIsVerified;
    }
    if (field === 'password') {
        return isFieldInvalid(state)(field);
    }
    return normalValidation;
};
export const getInvalidFields = (state) => Object.keys(state.signupForm).filter(isFieldMissingOrInvalid(state));
export const isFieldVisitedAndInvalid = (state, field) => {
    if (!state.fieldsClearedForValidation[field])
        return false;
    return isFieldMissingOrInvalid(state)(field);
};
const areSomeFormFieldsNotCompleted = (fields) => (state) => fields.some(isFieldMissingOrInvalid(state));
export const isFormOneIncomplete = areSomeFormFieldsNotCompleted(['firstName', 'lastName', 'email', 'phone']);
export const isOfferFormOneIncomplete = (state, isPasswordRequired) => (isPasswordRequired
    ? areSomeFormFieldsNotCompleted(['firstName', 'lastName', 'email', 'companyName', 'password'])(state)
    : areSomeFormFieldsNotCompleted(['firstName', 'lastName', 'email', 'companyName'])(state));
export const esbFormOneFields = ['companyName', 'country', 'street1', 'city', 'state', 'postalCode', 'phone'];
export const isEsbFormOneIncomplete = areSomeFormFieldsNotCompleted(esbFormOneFields);
export const isEsbFormTwoIncomplete = areSomeFormFieldsNotCompleted(['firstName', 'lastName', 'email', 'password']);
export const isFormIncomplete = (state) => getInvalidFields(state).length > 0;
